import { Component } from '@angular/core';

import { ActivitiesBaseComponent } from '../../activities.base.service';

@Component({
  selector: 'app-activities-unshared',
  templateUrl: './activities-unshared.component.html',
  styleUrls: ['./activities-unshared.component.scss'],
})
export class ActivitiesUnsharedComponent extends ActivitiesBaseComponent {}
